var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluenote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.99,
    height: 27.99,
    rx: 8.75,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7436 8.15625H10.4974C10.1882 8.15625 9.89164 8.27908 9.67301 8.49771C9.45437 8.71635 9.33154 9.01289 9.33154 9.32208V18.6488C9.33154 18.9579 9.45437 19.2545 9.67301 19.4731C9.89164 19.6918 10.1882 19.8146 10.4974 19.8146H17.4924C17.8016 19.8146 18.0981 19.6918 18.3167 19.4731C18.5354 19.2545 18.6582 18.9579 18.6582 18.6488V11.0708L15.7436 8.15625Z",
    stroke: "#155DFC",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1606 8.15625V10.4884C15.1606 10.7977 15.2835 11.0943 15.5022 11.313C15.7209 11.5317 16.0175 11.6545 16.3267 11.6545H18.6589",
    stroke: "#155DFC",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8297 12.2363H11.6636",
    stroke: "#155DFC",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3269 14.5684H11.6636",
    stroke: "#155DFC",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3269 16.8999H11.6636",
    stroke: "#155DFC",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluenote);
export default __webpack_public_path__ + "static/media/bluenote.e9f8518d44b82a3922821cf5cd61d8c0.svg";
export { ForwardRef as ReactComponent };